import {createAction} from 'redux-act';

export const GET_SALES_PER_ITEM = createAction(
  'analyticsSalesPerItem/GET_SALES_PER_ITEM'
);
export const GET_SALES_PER_ITEM_SUCCESS = createAction(
  'analyticsSalesPerItem/GET_SALES_PER_ITEM_SUCCESS'
);
